<template>
    <div>
        <div>
            <a href="/apps/script-tags/data-manager-os">Back to OS</a>
        </div>
        <h2>Data Manager</h2>
        <div style="width: 700px;">
            <form @submit="saveOsVersion">
                OS Version:<br />
                <b-form-input id="input-2" placeholder="" v-model="edit_os_version.dm_os_version"></b-form-input><br/>
                <b-button id="input-5" type="submit" variant="success">Save</b-button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            edit_os_version: {
                id: 0,
                dm_os_version: '',
                dm_os_name: this.$route.params.os
            }
        }
    },
    async created() {

    },
    methods: {
        async saveOsVersion(e) {
            e.preventDefault()
            const data = await this.$http.post(this.resources.Management.tgSaveOsVersion, {
                id: this.edit_os_version.id,
                dm_os_version: this.edit_os_version.dm_os_version,
                dm_os_name: this.edit_os_version.dm_os_name
            })

            this.notifySuccess('Saved')
            this.edit_os_version.dm_os_version = ''
        },
    },
}
</script>

<style scoped>
.input-cont {
    padding-bottom: 10px;
}

.subs_textarea {
    resize: none;
    width: 100%;
    height: 400px;
}
</style>